import { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import useStyles, { ChatButton } from './index.styles';

import CustomerChatMessenger from './ChatMessenger';
import CustomerResponse from './CustomerResponse';
import ChatHeader from './ChatHeader';

import { getAccessToken } from 'utils/auth';
import Loader from './Loader';
import {
  agentSocket,
  isAgentAvailable,
  setAgentSocket,
} from 'store/reducer/customerReducer';
import { useAppDispatch, useAppSelector } from 'hooks/useRedux';

const CustomerChatScreen = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { id: customerId } = useParams();

  const socket = useAppSelector(agentSocket);
  const agentAvailable = useAppSelector(isAgentAvailable);

  // const [socket, setSocket] = useState<WebSocket | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [startTime, setStartTime] = useState<Date | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  const token = getAccessToken();

  useEffect(() => {
    if (!socket) {
      setIsLoading(true);
      const newSocket = new WebSocket(
        `wss://zcgrcm9a45.execute-api.ap-south-1.amazonaws.com/stage?token=${token}&customer_id=${customerId}`
      );
      dispatch(setAgentSocket(newSocket));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  // on first render, if the web socket has already been established
  useEffect(() => {
    if (socket) {
      setStartTime(new Date());
      setIsLoading(false);
      setIsConnected(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (socket) {
      socket.onopen = (data) => {
        setStartTime(new Date());
        setIsLoading(false);
        setIsConnected(true);
      };

      socket.onerror = (error) => {
        console.error('WebSocket error:', error);
        setIsLoading(false);
      };

      socket.onclose = () => {
        console.log('WebSocket connection closed.');
      };

      // return () => {
      //   if (!agentAvailable) socket.close();
      //   setIsConnected(false);
      // };
    }
  }, [socket, agentAvailable]);

  if (isLoading) return <Loader />;

  return (
    <>
      <Box className={classes.wrapper}>
        <ChatHeader startTime={startTime} />

        <Box className={classes.contentWrapper}>
          <CustomerChatMessenger
            socket={socket}
            isConnected={isConnected}
            setIsLoading={setIsLoading}
            setStartTime={setStartTime}
          />

          <CustomerResponse />

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              paddingRight: '1rem',
            }}
          >
            <ChatButton>
              <Typography>CREATE & COPY</Typography>
            </ChatButton>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CustomerChatScreen;
